import React from 'react';

export default function IcStarFill() {
    return (
        <svg height="24px" style={{ maxHeight: "100%" }} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            viewBox="0 0 24 24">
            <g id="Atendimento">
                <g transform="translate(-471.000000, -420.000000)">
                    <g id="Box" transform="translate(351.000000, 243.000000)">
                        <g id="Comentários" transform="translate(24.000000, 76.000000)">
                            <g id="Text-area">
                                <g id="Rating" transform="translate(0.000000, 101.000000)">
                                    <path id="Path" d="M119.7,10l-5.3,5.4l1.2,7.6c0.1,0.3-0.1,0.7-0.3,0.9c-0.1,0.1-0.3,0.2-0.5,0.2c-0.1,0-0.3,0-0.4-0.1
							l-6.5-3.6l-6.5,3.6c-0.3,0.2-0.6,0.1-0.9-0.1c-0.3-0.2-0.4-0.5-0.3-0.9l1.2-7.6L96.3,10C96,9.8,95.9,9.4,96,9.1
							c0.1-0.3,0.4-0.6,0.7-0.6l7.3-1.1l3.3-6.9c0.3-0.6,1.2-0.6,1.5,0l3.3,6.9l7.3,1.1c0.3,0,0.6,0.3,0.7,0.6
							C120.1,9.4,120,9.7,119.7,10z"/>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
